module.exports = __webpack_public_path__ + "img/target_symbol.f90c36c5.svg";